import { useEffect, ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface PathNormalizationProviderProps {
  children: ReactNode;
}

export default function PathNormalizationProvider({
  children,
}: PathNormalizationProviderProps) {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname !== '/' && pathname.endsWith('/')) {
      navigate(`${pathname.replace(/\/+$/, '')}${search}${hash}`, {
        replace: true,
      });
    }
  }, [pathname, search, hash, navigate]);

  return children;
}
